import React from 'react';

import styles from './metricsStyles';

import DocumentList from 'buyside/components/presentation/DocumentList/documentList';

import { employerProfileDocumentUrl } from 'buyside/util/urlHelper';
import { formatDate } from 'buyside/util/dateHelper';

const Metrics = ({ fundProfile }) => {
  const { beta, sharpeRatio, turnoverRatio, metricsDocuments, metricsUpdatedAt } = fundProfile;
  const items = [
    { label: 'Beta', value: beta ? `${beta}` : null },
    { label: 'Sharpe Ratio', value: sharpeRatio ? `${sharpeRatio}` : null },
    { label: 'Turnover Ratio', value: turnoverRatio ? `${turnoverRatio}%` : null }
  ].filter(item => item.value);
  return (
    <div>
      <ul className={styles.metricsList}>
        {items.map((item, idx) => (
          <li key={idx}>
            <h4>{item.label}</h4>
            <span>{item.value}</span>
          </li>
        ))}
      </ul>
      <div className={styles.metricsFooter}>
        <em>Metrics updated as of {formatDate(metricsUpdatedAt)}.</em>
      </div>
      {!!metricsDocuments.length && (
        <DocumentList
          title="Supporting Documents"
          documents={metricsDocuments}
          urlFn={employerProfileDocumentUrl}
        />
      )}
    </div>
  );
};

export default Metrics;
